import React from 'react';
import { Form, Checkbox } from 'antd';

const Payroad = ({ form, disabled }) => {
  const { getFieldDecorator } = form;
  return (
    <div className="monetization-field">
      <div className="monetization-field__item3">
        <Form.Item extra="">
          {getFieldDecorator('deviation', {
            valuePropName: 'checked',
          })(
            <Checkbox disabled={disabled}>
              Возможность отклонения от маршрута
            </Checkbox>
          )}
        </Form.Item>
      </div>
      <div className="monetization-field__item3">
        <Form.Item extra="">
          {getFieldDecorator('payroad', {
            valuePropName: 'checked',
          })(
            <Checkbox disabled={disabled}>
              Наличие платных участков автодорог по маршруту следования
            </Checkbox>
          )}
        </Form.Item>
      </div>
    </div>
  );
};

export default Payroad;
